import React from "react";
import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import MyAppBar from "../AppBar/AppBar";
import Banner from "./Banner";
import yelpLogo from "../../assets/5-Star-Yelp-copy-1.png";
import googleReviews from "../../assets/5-Star-Google-Reviews.png";
import guildQuality from "../../assets/Guild-Quality-1.png";
import Footer from "../Footer/Footer";

const testimonials = [
  {
    id: 1,
    text: "I’d like to give a shout out to Alex and his crew for doing a great job on our backsplash. He is attentive and has clear communication skills. Alex kept in contact with me throughout process to ensure things were moving smoothly. He’s very nice and personable, and his customer service is spot on. I wouldn’t hesitate to hire his company again.",
    author: "Robyn L.",
    location: "Chicago, IL",
    logo: yelpLogo,
  },
  {
    id: 2,
    text: "My family used Prorenovations  for a few home improvement projects and they have all been fantastic experiences. Alex did a great job and we always felt like a priority. We will definitely use Prorenovations  in the future and recommend it to everyone.",
    author: "Angelina M.",
    location: "Naperville, IL",
    logo: googleReviews,
  },
  {
    id: 3,
    text: "Alex with Prorenovations  just did our bathroom remodel in June 2018. He was very friendly, professional and organized and made sure his sub-contractors each did a great job on their part of the project. We highly recommend Alex and Prorenovations  and plan on using him again for a couple future projects!",
    author: "Ronda & Dave R.",
    location: "Evanston, IL",
    logo: googleReviews,
  },
  {
    id: 4,
    text: "The team at Prorenovations  was amazing! They remodeled our kitchen, and the results are stunning. The quality of their work is top-notch, and they finished the project on time. We couldn’t be happier.",
    author: "Michael B.",
    location: "Aurora, IL",
    logo: yelpLogo,
  },
  {
    id: 5,
    text: "Prorenovations  exceeded our expectations. Their attention to detail and craftsmanship are unmatched. We are thrilled with our new living room and will definitely call them for future projects.",
    author: "Sarah H.",
    location: "Elgin, IL",
    logo: googleReviews,
  },
  {
    id: 6,
    text: "Alex and his team were fantastic from start to finish. They transformed our backyard into an oasis, and the whole process was smooth and hassle-free. Highly recommended!",
    author: "David C.",
    location: "Schaumburg, IL",
    logo: guildQuality,
  },
  {
    id: 7,
    text: "We hired Prorenovations  for a complete home renovation, and the results are phenomenal. They were professional, efficient, and communicated with us every step of the way. We are so happy with our new home.",
    author: "Emily R.",
    location: "Wheaton, IL",
    logo: googleReviews,
  },
  {
    id: 8,
    text: "Alex is the best! He remodeled our bathroom, and it looks like a spa now. The quality of work is excellent, and the project was completed on time and within budget. Thank you, Prorenovations !",
    author: "Jessica T.",
    location: "Arlington Heights, IL",
    logo: yelpLogo,
  },
  {
    id: 9,
    text: "Prorenovations  did a fantastic job on our deck. The craftsmanship is superb, and the team was professional and courteous. We love our new outdoor space!",
    author: "Chris W.",
    location: "Oak Park, IL",
    logo: guildQuality,
  },
  {
    id: 10,
    text: "We had a great experience with Prorenovations . They remodeled our basement, and the transformation is amazing. Alex and his crew were professional and efficient. We highly recommend them.",
    author: "Anna K.",
    location: "Glenview, IL",
    logo: yelpLogo,
  },
  {
    id: 11,
    text: "Alex and his team did an excellent job on our kitchen remodel. They were professional, clean, and respectful of our home. The finished product is beautiful, and we couldn’t be happier.",
    author: "Mark P.",
    location: "Naperville, IL",
    logo: googleReviews,
  },
  {
    id: 12,
    text: "Prorenovations  did a wonderful job on our bathroom remodel. The attention to detail was impressive, and the team was very friendly and professional. We are thrilled with the results!",
    author: "Karen S.",
    location: "Hoffman Estates, IL",
    logo: guildQuality,
  },
  {
    id: 13,
    text: "Alex and his crew were amazing! They transformed our old, outdated kitchen into a modern, functional space. The quality of their work is exceptional, and they finished the project on time. Highly recommended!",
    author: "Jason L.",
    location: "Palatine, IL",
    logo: guildQuality,
  },
  {
    id: 14,
    text: "We are so happy with the work Prorenovations  did on our home. They were professional, efficient, and their craftsmanship is top-notch. We will definitely use them again for future projects.",
    author: "Susan M.",
    location: "Skokie, IL",
    logo: googleReviews,
  },
  {
    id: 15,
    text: "Prorenovations  transformed our backyard into a beautiful outdoor living space. Alex and his team were great to work with, and their attention to detail was incredible. We couldn’t be happier with the results.",
    author: "Greg D.",
    location: "Naperville, IL",
    logo: guildQuality,
  },
];

const TestimonialCard = ({ testimonial }) => (
  <Card sx={{ maxWidth: 345, margin: 2 }}>
    <CardContent>
      <Box sx={{ textAlign: "center" }}>
        <img
          alt="Review Logo"
          src={testimonial.logo}
          style={{ width: "80px", height: "auto", margin: "0 auto" }}
        />
      </Box>
      <Typography variant="body1" sx={{ mt: 2 }}>
        {testimonial.text}
      </Typography>
      <Typography variant="body2" sx={{ mt: 2, fontWeight: "bold" }}>
        {testimonial.author}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {testimonial.location}
      </Typography>
    </CardContent>
  </Card>
);

const Testimonials = () => {
  return (
    <Box>
      <MyAppBar />
      <Banner />
      <Box sx={{ p: 4 }}>
        <Grid container justifyContent="center">
          {testimonials.map((testimonial) => (
            <TestimonialCard key={testimonial.id} testimonial={testimonial} />
          ))}
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default Testimonials;
